import { Base } from '@studiometa/js-toolkit';
import Fade from './Fade.js';
import SectionSlices from './SectionSlices.js';

/**
 * Animations component
 */
export default class Animations extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Animations',
    components: {
      '[data-fade]': Fade,
      SectionSlices,
    },
  };
}
